<template>
  <!-- 写私信对话框封装 -->
  <div>
    <el-dialog
      title="写私信"
      class="eoistolize"
      :visible.sync="visible"
      width="720px"
      @close="$emit('update:show', false)"
      :show="show"
      append-to-body
    >
      <el-form
        :model="eoistolizForm"
        :rules="rules"
        ref="eoistolizForm"
        label-width="54px"
      >
        <el-form-item label="收信人" prop="name">
          <el-input v-model="name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="主题" prop="subject">
          <el-input
            v-model="eoistolizForm.subject"
            placeholder="请输入主题"
          ></el-input>
        </el-form-item>
        <el-form-item class="textarea-item" prop="textarea">
          <el-input
            type="textarea"
            placeholder="说点什么吧"
            v-model="eoistolizForm.textarea"
            maxlength="500"
            show-word-limit
            class="textarea"
            style=" 100%"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="height: 32px" @click="visible = false" class="bnt"
          >取 消</el-button
        >
        <el-button
          style="height: 32px"
          type="primary"
          @click="listSubmit('eoistolizForm')"
          class="bnt"
          >立即创建</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
//import {  } from ''//
import { getMessageSendInfo } from '@/api/message.js';

export default {
  data() {
    return {
      //写私信对话框
      visible: this.show,
      eoistolizForm: {
        uuid: '',
        subject: '',
        textarea: '',
      },
      eoistolizeOptions: [],
      messageUuid: '',
      rules: {
        // name: [{ required: true, message: '请填写收信人', trigger: 'change' }],
        subject: [{ required: true, message: '请输入主题', trigger: 'blur' }],
        textarea: [
          { required: true, message: '请填写私信内容', trigger: 'blur' },
        ],
      },
    };
  },
  // vue父传子props 组件传值
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
    uuid: {
      type: String,
      default: '',
    },
  },
  watch: {
    show() {
      this.visible = this.show;
    },
  },
  created() {
    this.messageUuid = this.uuid;
  },
  mounted() {},
  methods: {
    //写私信
    async listSubmit(formName) {
      let sendMessageObj = {
        uuid: this.uuid,
        subject: this.eoistolizForm.subject,
        content: this.eoistolizForm.textarea,
      };
      //console.log('发送对象：', sendMessageObj);
      const { data: res } = await getMessageSendInfo(sendMessageObj);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$message.error({
            message: res.msg,
            duration: 1000,
          });
          this.visible = false;
          this.eoistolizForm.subject = '';
          this.eoistolizForm.textarea = '';
        }
      });
    },
  },
};
</script>


<style lang="scss" scope>
.eoistolize {
  .el-dialog {
    height: 612px;
    background: #33353e !important;
    border-radius: 8px;
    .el-dialog__header {
      height: 70px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      .el-dialog__title {
        line-height: 71px;
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: #d1d4dc;
        margin-left: 20px;
      }
    }
    .el-dialog__body {
      //   height: 100%;
      margin: 35px 20px 16px 20px;
      .el-form {
        .el-form-item {
          margin-bottom: 32px;
          .el-form-item__label {
            height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #d1d4dc;
            text-align: justify;
          }
          .el-form-item__label::after {
            content: ' ';
            width: 100%;
            display: inline-block;
          }
          .el-form-item__content {
            .el-select {
              .el-select__tags {
                .el-select__input {
                  font-size: 14px;
                  font-family: MicrosoftYaHei;
                  color: #d1d4dc !important;
                }
              }
              .el-input {
                .el-input__inner {
                  border: none;
                  background: rgba(255, 255, 255, 0.1);
                  border-radius: 4px;
                }
                .el-input__suffix {
                  display: none;
                }
              }
            }
            .el-input {
              .el-input__inner {
                background: rgba(255, 255, 255, 0.1) !important;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: #d1d4dc;
                border: none;
              }
            }
            .textarea {
              height: 263px !important;
              .el-input__inner {
                height: 206px;
                overflow-y: auto;
                border: none;
                background: rgba(255, 255, 255, 0.1);
                border-radius: 4px;
              }
              .el-input__suffix {
                .el-input__suffix-inner {
                  .el-input__count {
                    // display: inline-flex;
                    // align-items: flex-end;
                    .el-input__count-inner {
                      background: transparent;
                      font-size: 14px;
                      font-family: PingFangSC-Regular, PingFang SC;
                      font-weight: 400;
                      color: #d1d4dc;
                      padding: 16px 16px;
                    }
                  }
                }
              }
            }
            .el-textarea {
              .el-textarea__inner {
                resize: none;
                height: 263px !important;
                overflow-y: auto;
                border: none;
                background: rgba(255, 255, 255, 0.1);
                border-radius: 4px;
                max-height: 263px;
                min-height: 263px !important;
                padding: 12px 16px 16px 16px;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: #d1d4dc;
              }
              .el-input__count {
                background: transparent;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #d1d4dc;
              }
            }
          }
        }
        // .textarea-item{
        //     .el-form-item__content{
        //         //margin-left: 0 !important;
        //     }
        // }
      }
    }
    .el-dialog__footer {
      padding: 8px 20px 20px;
      .dialog-footer {
        .bnt {
          height: 32px !important;
        }
        .el-button {
          line-height: 32px !important;
          width: 72px;
          height: 32px !important;
          border-radius: 4px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          background: rgba(51, 53, 62, 1);
          margin: 0 0 0 12px !important;
          padding: 0 !important;
          span {
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #d1d4dc;
          }
        }
        .el-button--primary {
          background: #edbd88 !important;
          border: none;
          span {
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #33353e;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popover/PrivateMessagePopover.vue